export default defineNuxtRouteMiddleware(async () => {
  const { $switchRoute } = useI18n()
  const { isLogged, isFetching } = storeToRefs(useUser())

  await until(isFetching).toBe(false)

  if (!isLogged.value)
    return $switchRoute('/login')
})
